import {AfterViewInit, Component, effect, input, OnDestroy, ViewChild}   from '@angular/core';
import {TwColorType, VapeRecordSumCountIntf}                             from '@djsharkk/logr-types';
import {ChartConfiguration, ChartOptions, Point, ScriptableChartContext} from 'chart.js';
import {Options}                                                         from 'chartjs-plugin-datalabels/types/options';
import {DateTime}                                                        from 'luxon';
import {Subscription}                                                    from 'rxjs';
import {ChartBarComponent}                                               from '../../comps/chart-bar/chart-bar.component';
import {avgDataCalc}                                                     from '../averages.calc';
import {ChartCatsBase}                                                   from '../chart-cats.base';


@Component({
			   selector   : 'app-chart-vape-sum',
			   imports    : [
				   ChartBarComponent
			   ],
			   templateUrl: './chart-vape-sum.component.html',
			   styleUrl   : './chart-vape-sum.component.css'
		   })
export class ChartVapeSumComponent extends ChartCatsBase<ChartBarComponent, 'bar' | 'line'> implements OnDestroy, AfterViewInit {
	@ViewChild(ChartBarComponent) chartComponent!: ChartBarComponent;

	dayCount = input<number>()
	mgType = input<('qtyTotal' | 'thcTotal')>('qtyTotal')

	datalabels = (color: TwColorType, avg = false): Options => ({
		formatter: (value: Point) => {
			console.log(value);
			return `${DateTime.fromMillis(value.x).toFormat('MM-dd').toUpperCase()}: ${value.y.toFixed()}mg`
		},
		color    : this.svcUiTheme.getTailwindColor(color, 600),
		align    : avg ? 'top' : 'bottom'
	})

	conf: ChartConfiguration<'bar' | 'line', Point[]> = {
		data   : {
			datasets: [
				{
					...this.svcChartProps.avgStyle,
					label     : '3 Day Moving Average',
					datalabels: this.datalabels('orange', true)
				},
				{
					backgroundColor : (ctx: ScriptableChartContext) => this.svcChartTheme.checkGradient(
						ctx,
						[
							this.svcUiTheme.getTailwindColor('lime', 950, 0),
							this.svcUiTheme.getTailwindColor('lime', 950, 0.25)
						]
					),
					borderColor     : this.svcUiTheme.getTailwindColor('lime', 900),
					borderWidth     : 1,
					pointRadius     : 2,
					pointStyle      : 'circle',
					pointBorderColor: this.svcUiTheme.getTailwindColor('lime', 600),
					pointBorderWidth: 0,
					fill            : true,
					label           : 'Total',
					data            : [],
					tension         : 0.1,
					datalabels      : this.datalabels('lime')
				}


			],
			labels  : []
		},
		options: {
			...this.svcChartProps.optsDayBar
		},
		plugins: [],
		type   : 'line'
	};

	recordsSub?: Subscription

	constructor() {
		super();

		effect(() => {
			this.conf.data.datasets.forEach((dataset, i) => {
				dataset.datalabels = {
					...dataset.datalabels,
					display: this.dayCount() === undefined ? false : 'auto'
				}
			})

			const annotations = this.conf.options?.plugins?.annotation?.annotations;
			if (annotations) {
				this.svcChartProps.buildAnnotation({
													   type       : 'line',
													   yMin       : this.mgType() === 'qtyTotal' ? 500 : 150,
													   yMax       : this.mgType() === 'qtyTotal' ? 500 : 150,
													   borderWidth: 2,
													   borderColor: this.svcUiTheme.getTailwindColor('neutral', 600, 0.5),
													   borderDash : [
														   2,
														   4
													   ]
												   }, 'Optimal', this.conf.options as ChartOptions)
			}
		})

		const scales = this.conf.options?.scales;
		if (scales) {
			if (scales['y']) {
				scales['y'] = {
					...scales['y'],
					offset: true,
					ticks : {
						...scales['y']?.ticks,
						mirror  : true,
						callback: (tickValue, index, ticks) => index === 0 ? '' : tickValue
					}
				}
			}
			if (scales['x']) {
				scales['x'] = {
					...scales['x'],
					offset : false,
					display: !this.dayCount(),
					ticks  : {
						...scales['x']?.ticks,
						align : 'inner',
						mirror: true
					}
				}
			}
		}
	}

	ngAfterViewInit() {

		this.recordsSub = this.svcDataFactory.svcDataVape.getRecordsSum()?.subscribe((records) => {

			const countN = this.dayCount();
			const min = DateTime.fromMillis(Math.min(...records.map(record => record.timestamp.toMillis()))).startOf('day');
			const max = DateTime.fromMillis(Math.max(...records.map(record => record.timestamp.toMillis()))).startOf('day');

			if (this.conf.options?.scales) {
				this.conf.options.scales = {
					...this.conf.options.scales,
					x: {
						...this.conf.options.scales['x'],
						min: countN ? max.minus({days: countN - 1}).toMillis() : min.toMillis(),
						max: max.toMillis()
					}
				}
			}


			const avg3 = records.map((record): Point => ({
				x: DateTime.fromMillis(record.timestamp.toMillis()).startOf('day').plus({day: 2}).toMillis(),
				y: record.overall[this.mgType() as keyof VapeRecordSumCountIntf]
			}));

			const data: Point[] = records
				.map(record => ({
					x: DateTime.fromMillis(record.timestamp.toMillis()).startOf('day').toMillis(),
					y: record.overall[this.mgType() as keyof VapeRecordSumCountIntf]
				}))


			const dataAvg3 = avgDataCalc(avg3);

			this.chartComponent?.updateDataset(0, {
				data: countN ? dataAvg3.slice(-countN) : dataAvg3
			})

			this.chartComponent?.updateDataset(
				1,
				{
					data: countN ? data.slice(-countN) : data
				}
			)


		})


	}


}
